import { Button, Grid2 } from '@mui/material'
import { Formik, Field, Form } from "formik";
import * as Yup from "yup";
import { sharedValidationSchema } from './SharedSchema';
import { useApartmentListForCourse, useBatchList, useStudentCourseNameList } from '../../assets/api/useAdminApi';
import { IdAutoCompleteField } from '../../shared/components/formfields/IdAutoCompleteField';
import { DateFormField } from '../../shared/components/formfields/DataFormField';
import { TextFormField } from '../../shared/components/formfields/TextFormField';
import { TimeFormField } from '../../shared/components/formfields/TimeFormFields';
import { useMutation } from '@tanstack/react-query';
import { useToaster } from '../../shared/utils/ToasterProvider';
import { Grid_Gap } from '../../shared/constants';
import CustomDivider from '../../shared/utils/CustomDivider';
import api from '../../assets/nodeApi/axiosInstance';
import { useState } from 'react';

const CourseLinkForm = () => {
    const [selectedCourse, setSelectedCourse] = useState({})
    const { showToaster } = useToaster();
    const { data: courseList, isLoading } = useStudentCourseNameList();
    const CoursesOptions = courseList?.data?.map(course => ({
        id: course?.id,
        label: course?.course_name,
        value: course?.course_name,
        ...course
    })) || [];
    const { data: apartmentList, isLoading: isLoadingApartmentList } = useApartmentListForCourse();
    // const ApartmentOptions = apartmentList?.data?.map((item) => ({
    //     id: item?.id,
    //     label: item?.apartment_name,
    //     value: item?.apartment_name,
    // })) || [];
    const ApartmentOptions = (apartmentList?.data || [])
        .filter(item =>
            [1, 2, 0].includes(item?.status)
        )
        .map(item => ({
            id: item?.id,
            label: item?.apartment_name,
            value: item?.apartment_name,
        }));

    // const ApartmentOptions = apartmentList?.data
    //     ?.filter((item) => item?.status === 0)
    //     .map((item) => ({
    //         id: item?.id,
    //         label: item?.apartment_name,
    //         value: item?.apartment_name,
    //     })) || [];

    const { data: batchList, isLoading: isBatchListLoading } = useBatchList();
    const BatchOptions = batchList?.data?.map((item) => ({
        id: item?.id,
        label: item?.batch_name,
        value: item?.batch_name,
    })) || [];
    const validationSchema = Yup.object().shape({
        course_id: Yup.string().required("Course is required"),
        course_fees: Yup.number()
            .typeError("Price must be a number")
            .min(0, "Price must be 0 or greater")
            .required("Price is required"),
        ...sharedValidationSchema,
    });
    const initialValues = {
        course_id: null,
        start_date: null,
        end_date: null,
        start_time: null,
        end_time: null,
        course_fees: "",
    };

    const mutation = useMutation({
        mutationFn: (formData) => api.post("collab-apartment/create", formData),
    });
    const handleSubmit = (values, { setSubmitting, resetForm }) => {
        mutation.mutate(values, {
            onSuccess: (response) => {
                if (response?.data?.status === "success") {
                    showToaster('Success', response?.data?.message, 'success')

                } else {
                    showToaster("Error Caught While submiting the form", 'Error', 'error');
                }
                resetForm();
            },
            onError: () => {
                showToaster("Error Caught While submiting the form", 'Error', 'error');
            },
            onSettled: () => {
                setSubmitting(false);
            },
        });

    }
    return (
        <Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={handleSubmit}>
            {({ values, resetForm }) => (
                <Form>
                    <Grid2 container spacing={Grid_Gap}>
                        <Grid2 children size={{ xs: 12, sm: 4 }}>
                            <Field
                                name="course_id"
                                component={IdAutoCompleteField}
                                options={CoursesOptions}
                                label="Course"
                                isRequired={true}
                                isLoading={isLoading}
                                onValueChange={(val) => { setSelectedCourse(val) }}
                            />
                        </Grid2>
                        {selectedCourse?.online !== 1 &&
                            <Grid2 children size={{ xs: 12, sm: 4 }}>
                                <Field
                                    name="apartments_id"
                                    component={IdAutoCompleteField}
                                    options={ApartmentOptions}
                                    label="Apartment"
                                    isRequired={true}
                                    isLoading={isLoadingApartmentList}
                                />
                            </Grid2>
                        }

                        {/* <Grid2 children size={{ xs: 12, sm: 4 }}>
                            <Field
                                name="batch_id"
                                component={IdAutoCompleteField}
                                options={BatchOptions}
                                label="Batch"
                                isRequired={true}
                                isLoading={isBatchListLoading}
                            />
                        </Grid2> */}
                        <Grid2 children size={{ xs: 12, sm: 4 }}>
                            <Field
                                name="start_date"
                                component={DateFormField}
                                label="Start Date"
                                isRequired={true}
                                minDate={new Date()}
                                maxDate={values.end_date || undefined}
                            />
                        </Grid2>
                        <Grid2 children size={{ xs: 12, sm: 4 }}>
                            <Field
                                name="end_date"
                                component={DateFormField}
                                label="End Date"
                                isRequired={true}
                                minDate={values.start_date || undefined || new Date()}
                            />
                        </Grid2>
                        <Grid2 children size={{ xs: 12, sm: 4 }}>
                            <Field
                                name="start_time"
                                component={TimeFormField}
                                label="Start Time"
                                isRequired={true}

                            />
                        </Grid2>
                        <Grid2 children size={{ xs: 12, sm: 4 }}>
                            <Field
                                name="end_time"
                                component={TimeFormField}
                                label="End Time"
                                isRequired={true}
                            />
                        </Grid2>

                        <Grid2 children size={{ xs: 12, sm: 4 }}>
                            <Field
                                name="course_fees"
                                component={TextFormField}
                                label="Price"
                                isRequired={true}
                                type={"number"}
                            />
                        </Grid2>


                    </Grid2>
                    <CustomDivider />
                    <Grid2 container spacing={Grid_Gap} sx={{ display: "flex", justifyContent: "end" }}>
                        <Grid2 children size={{ xs: 12, sm: 3 }}>
                            <Button variant='outlined' fullWidth onClick={resetForm}>Cancel</Button>
                        </Grid2>
                        <Grid2 children size={{ xs: 12, sm: 3 }}>
                            <Button variant='contained' type="submit" fullWidth>Submit</Button>
                        </Grid2>
                    </Grid2>
                </Form>
            )}
        </Formik>
    )
}

export default CourseLinkForm